// extracted by mini-css-extract-plugin
export default {"header":"MailComplete_header__sRcvm","title":"MailComplete_title__pDjEG"};